import { NewspaperIcon } from "@heroicons/react/24/solid";
import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import LobTypes from "./LobType";
import CarrierProgram from "./CarrierProgram";
import ProducerCodeType from "./ProducerCodeType";
import MGA from "./MGA";
import DistributionChannel from "./DistributionChannel";
import CodeLevel from "./CodeLevel";
export const ProducerConfigurationTabs = [
  {
    to: ROUTE_PATHS.Utilities_ProducerConfiguration_LobType,
    path: "/utilities/ProducerConfiguration/LobType",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "LOB Type",
    component: LobTypes,
    permission: PERMISSIONS.permission_utilities_lobtype_view,
  },
  {
    to: ROUTE_PATHS.Utilities_ProducerConfiguration_CarrierProgram,
    path: "/utilities/ProducerConfiguration/CarrierProgram",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Carrier Program",
    component: CarrierProgram,
    permission: PERMISSIONS.permission_utilities_carrierprogram_view, // to add persmission
  },
  {
    to: ROUTE_PATHS.Utilities_ProducerConfiguration_ProducerCodeType,
    path: "/utilities/ProducerConfiguration/ProducerCodeType",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Producer Code Type",
    component: ProducerCodeType,
    permission: PERMISSIONS.permission_utilities_producercodetype_view, // to add persmission
  },
  {
    to: ROUTE_PATHS.Utilities_ProducerConfiguration_MGA,
    path: "/utilities/ProducerConfiguration/MGA",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "MGA",
    component: MGA,
    permission: PERMISSIONS.permission_utilities_mga_view, // to add persmission
  },
  {
    to: ROUTE_PATHS.Utilities_ProducerConfiguration_DistributionChannel,
    path: "/utilities/ProducerConfiguration/DistributionChannel",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Distribution Channel",
    component: DistributionChannel,
    permission: PERMISSIONS.permission_utilities_distributionchannel_view, // to add persmission
  },
  {
    to: ROUTE_PATHS.Utilities_ProducerConfiguration_CodeLevel,
    path: "/utilities/ProducerConfiguration/CodeLevel",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Code Level",
    component: CodeLevel,
    permission: PERMISSIONS.permission_utilities_codelevel_view, // to add persmission
  },
];
